import Vue from "vue";
import VueAzureMaps from "vue-azure-maps";
import "./../assets/scss/vue-azure-maps.css";

Vue.use(VueAzureMaps, {
  key: "EHKNH-01UWNQCISrhATc_0_JWZbgNcPXJaLGVasgtvI",
});

export default VueAzureMaps;
